import * as React from "react";
import { forwardRef } from "react";
const SvgIconPin = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m11.149 2.562-.3.405L8.73 5.86a3.63 3.63 0 0 0-3.216 1l-.311.3 2.3 2.3L4 12.954v.608h.608l3.5-3.5 2.3 2.3.3-.311a3.63 3.63 0 0 0 1-3.216L14.6 6.713l.405-.3z", "data-name": "icon/sidebar/pin", transform: "translate(-3.5 -2.062)", fill: "rgba(255,255,255,.71)" }));
const ForwardRef = forwardRef(SvgIconPin);
export { ForwardRef as ReactComponent };
